import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import Grid from '@mui/material/GridLegacy';
import { useQuery } from 'react-query';
import PageBreadcrumbs from '../../shared/Pages/PageBreadcrumbs';
import { GetJoinOurNetworkGroupsFn } from '../../../data/apiCalls';
import PageBanner from '../../shared/Pages/PageBanner';
import PageMobileTitle from '../../shared/Pages/PageMobileTitle';
import NoResultsOverlay from '../../Errors/NoResultsOverlay';
import JoinOurNetworkImg from '../../../assets/JoinOurNetwork.jpg';
import useIsMobile from '../../../hooks/useIsMobile';
import { TOP_LEVEL_ROUTES } from '../../../scripts/routes';
import JONPageCard from './JONPageCard';
import JONPageCardSkeleton from './JONPageCardSkeletonLoading';

const JONGroupListPage = () => {
	const pageTitle = 'Join Our Network - Providers';

	const bannerTitle = 'TAKE YOUR PRACTICE TO THE NEXT LEVEL';

	const isMobile = useIsMobile();

	const {
		data: {
			status = undefined,
			data: { resultCode = undefined, data: { results = [] } = {} } = {},
		} = {},
		isLoading,
		isError,
	} = useQuery(
		['clinicalJoinOurNetworkGroups'],
		() => GetJoinOurNetworkGroupsFn(),
		{
			staleTime: Infinity,
		}
	);

	const showNoResultsOverlay = isError || (status >= 400 && status <= 505);

	const crumbs = [
		{
			text: pageTitle,
			link: `/${TOP_LEVEL_ROUTES.resources}/providers`,
		},
	];

	return (
		<Container sx={{ pb: 8 }}>
			{!isMobile && <PageBreadcrumbs crumbs={crumbs} />}
			<PageBanner imageUrl={JoinOurNetworkImg} title={bannerTitle} />
			{isMobile ? (
				<PageMobileTitle title={pageTitle} />
			) : (
				<>
					<Typography
						component='h2'
						variant='h4'
						sx={{ mt: 4, mb: 3 }}
					>
						{pageTitle}
					</Typography>
					<Divider sx={{ mb: 2 }} />
				</>
			)}

			<Typography
				component='h3'
				variant='body1'
				sx={{ mb: { xs: 3, md: 8 } }}
			>
				Thank you for your interest in becoming a contracted provider
				with American Specialty Health. To learn more about ASH and how
				to join our network, please select your specialty from the list
				below and see how ASH can take your practice to the next level.
			</Typography>
			{isLoading && <JONPageCardSkeleton />}
			{showNoResultsOverlay && (
				<Container sx={{ pt: 3 }}>
					<NoResultsOverlay
						resultCode={resultCode}
						statusCode={status}
					/>
				</Container>
			)}
			{!isLoading && !showNoResultsOverlay && (
				<Grid container spacing={2}>
					{results
						.sort((a, b) =>
							a.displayName.localeCompare(b.displayName)
						)
						.map(group => (
							<Grid
								item
								xs={12}
								sm={6}
								md={4}
								key={group.page.pageId}
							>
								<JONPageCard ClinicalPageData={group} />
							</Grid>
						))}
				</Grid>
			)}
		</Container>
	);
};

export default JONGroupListPage;
